import { ProjectSelectorPopover } from '@/features/dashboard/components/dashboard/project-selector-popover';
import { useUpdateDashboardProjectSlot } from '@/features/dashboard/hooks/use-dashboard-project-slots';
import { ProjectWithContractors } from '@/shared/types/api';

export const DashboardProjectSelector = ({
  project,
  slotIndex,
  isActive,
  trigger,
  children,
}: {
  project: ProjectWithContractors | null;
  slotIndex: number;
  isActive?: boolean;
  trigger?: React.ReactNode;
  children?: React.ReactNode;
}) => {
  const updateSlotMutation = useUpdateDashboardProjectSlot();
  const handleProjectSelect =
    (slotIndex: number) => (projectId: number | null) => {
      updateSlotMutation.mutate({
        slotIndex,
        projectId,
      });
    };
  const handleActiveChange = (slotIndex: number) => (isActive: boolean) => {
    updateSlotMutation.mutate({
      slotIndex,
      projectId: project?.id ?? null,
      isActive,
    });
  };

  return (
    <ProjectSelectorPopover
      selectedProjectId={project?.id ?? null}
      isActive={isActive}
      onProjectSelect={handleProjectSelect(slotIndex)}
      onActiveChange={handleActiveChange(slotIndex)}
      trigger={trigger}
      child={children}
    />
  );
};
